import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzInputModule } from 'ng-zorro-antd/input';
import { SvgIconModule } from '../svg-icon/svg-icon.module';
import { NewPasswordComponent } from './new-password.component';

@NgModule({
  declarations: [NewPasswordComponent],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, SvgIconModule, NzFormModule, NzInputModule],
  exports: [NewPasswordComponent],
})
export class NewPasswordModule {}
